import { createFileRoute } from '@tanstack/react-router';

import { exigirAcceso } from '@/entities/usuario';
import { ProyectoCreatePage } from '@/pages/proyecto-create';

export const Route = createFileRoute('/_private/proyectos/nuevo')({
  beforeLoad: () => exigirAcceso('proyectos', 'create'),
  component: ProyectoCreatePage,
});
